import * as React from 'react';
import { Loader2 } from 'lucide-react';
import { Button } from '@/components/ui/button';

type ButtonProps = React.ComponentProps<typeof Button>;

interface LoadingButtonProps extends ButtonProps {
  /** Whether the button is in a loading state */
  isLoading?: boolean;
  /** Custom loading icon (defaults to Loader2 spinner) */
  loadingIcon?: React.ReactNode;
}

/**
 * Button component with built-in loading state support.
 * Shows a spinner when loading and automatically disables the button.
 */
export function LoadingButton({
  isLoading = false,
  loadingIcon,
  disabled,
  children,
  ...props
}: LoadingButtonProps) {
  const spinner = loadingIcon ?? <Loader2 className="animate-spin" />;

  return (
    <Button disabled={disabled ?? isLoading} {...props}>
      {isLoading && spinner}
      {children}
    </Button>
  );
}
